import { v4 as uuid } from 'uuid';

export type Addressable = { internalAddressId: string };

export type MakeAddressable<T> = T & Addressable;

// NOTE: use this function to add internal ids to items that might not have actual database ids yet,
// so that they can still be referenced (addressable)
export function makeAddressable<T extends Record<string, unknown>>(
  item: T,
): MakeAddressable<T> {
  return {
    ...item,
    internalAddressId:
      'internalAddressId' in item && typeof item.internalAddressId === 'string'
        ? item.internalAddressId
        : uuid(),
  };
}
